<div class="preloader-wrap__big" *ngIf="!miniPreloader">
    <div class="preloader">
        <div class="preloader__icon" [ngClass]="{'disabled-spinning': disableSpinning}">
            <img class="lazy" [src]="imageSrc" data-src="{{imageSrc}}" width="242" height="242" alt="" data-loaded="true">
        </div>
        <div class="preloader__text" *ngIf="!defaultText">
           {{incomingText}}
        </div>
        <div class="preloader__text" *ngIf="defaultText">
            {{text}}
         </div>
    </div>
</div>

<div class="preloader-wrap__mini" *ngIf="miniPreloader">
    <div class="preloader--mini">
        <div class="preloader__icon"><img class="lazy" [src]="imageSrc" data-src="{{imageSrc}}" width="50" height="50" alt="" data-loaded="true"></div>
    </div>
    <div class="preloader_mini__text" *ngIf="!defaultText">
        {{incomingText}}
     </div>
</div>